<template>
    <div class="my-5 p-3">
        <div class="col-12 mb-5">
            <h2 v-html="header" class="text-white pb-4"></h2>
        </div>
        <form id="f-register" @submit.prevent="handleUpdateForm()" method="post">
            <div class="form-row">
                <form-input label="Imię:" size="col-md-6" type="text" :name="'name'" :modelValue="name" v-model="name" :error-messages="errorMessages"></form-input>
                <form-input label="Nazwisko:" size="col-md-6" :name="'last_name'" :modelValue="last_name" v-model="last_name" :error-messages="errorMessages"></form-input>
            </div>

            <div class="form-row">
                <form-select label="Wykonywany zawód:" size="col-md-6" :name="'profession'" :modelValue="profession" v-model="profession" :error-messages="errorMessages" :values="JSON.parse(professions)"></form-select>
                <form-input v-if="profession != 6 && profession != 3 && profession != 8" label="Numer prawa wykonywania zawodu:" :modelValue="pwz_number" size="col-md-6" type="text" :name="'pwz_number'" id="fr-pwz" maxlength="15" v-model="pwz_number" :error-messages="errorMessages"></form-input>
                <form-input v-if="profession == 4" label="Numer legitymacji studenckiej" :modelValue="card" size="col-md-6" type="text" :name="'card'" v-model="card" :error-messages="errorMessages"></form-input>
            </div>

            <!-- Ukryj miejsce pracy jeśli hideUpdateButton -->
            <div class="form-group" v-if="!hideUpdateButton && profession != 4 && profession != 6 && profession != 16">
                <form-textarea label="Miejsce pracy:" :name="'work_place'" rows="3" :modelValue="work_place" v-model="work_place" :error-messages="errorMessages"></form-textarea>
            </div>

            <div class="form-row">
                <form-input label="Telefon:" size="col-md-6" type="text" :modelValue="phone" :name="'phone'" id="fr-phon" maxlength="50" v-model="phone" :error-messages="errorMessages"></form-input>
                <form-input v-if="profession == 1" label="Specjalizacja:" :modelValue="specialization" size="col-md-6" type="text" :name="'specialization'" id="fr-specs" maxlength="100" v-model="specialization" :error-messages="errorMessages"></form-input>
                <form-input v-if="profession == 4" label="Uniwersytet:" :modelValue="university" size="col-md-6" type="text" :name="'university'" v-model="university" :error-messages="errorMessages"></form-input>
                <form-input v-if="profession == 6" label="Przedstawiciel firmy:" :modelValue="company_represented" size="col-md-6" type="text" :name="'company_represented'" v-model="company_represented" :error-messages="errorMessages"></form-input>
            </div>

            <!-- Ukryj hasła jeśli hideUpdateButton -->
            <div class="form-row" v-if="!hideUpdateButton">
                <form-input label="Nowe hasło:" size="col-md-6" type="password" :name="'password'" v-model="password" :error-messages="errorMessages"></form-input>
                <form-input label="Powtórz nowe hasło:" size="col-md-6" type="password" :name="'repeat_password'" v-model="repeat_password" :error-messages="errorMessages"></form-input>
            </div>

            <div class="row form-group-heading mt-5">
                <div class="col-lg-12">
                    <h3 class="text-white text-center">Dane do faktury</h3>
                </div>
            </div>

            <form-user-type class="mb-5 mt-4" :modelValue="user_type" v-model="user_type" :name="'user_type'" :errorMessages="errorMessages"></form-user-type>

            <div class="form" v-if="user_type">
                <div class="form-row">
                    <div class="col-lg-6">
                        <form-input :disactive="user_type === 'person'" :modelValue="company_name" size="form-group--small" label="Nazwa firmy" v-model="company_name" type="text" :name="'company_name'" :errorMessages="errorMessages"></form-input>
                    </div>
                    <div class="col-lg-6">
                        <form-input :disactive="user_type === 'person'" :modelValue="nip" size="form-group--small" label="NIP" v-model="nip" type="text" :name="'nip'" v-mask="[/\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, '-', /\d/, /\d/, '-', /\d/, /\d/]" :errorMessages="errorMessages"></form-input>
                    </div>
                    <div class="col-lg-6">
                        <form-input  size="form-group--small" :modelValue="street" label="Ulica" v-model="street" type="text" :name="'street'" :errorMessages="errorMessages"></form-input>
                    </div>
                    <div class="col-lg-3">
                        <form-input size="form-group--small" :modelValue="house_number" label="Numer domu" v-model="house_number" type="text" :name="'house_number'" :errorMessages="errorMessages"></form-input>
                    </div>
                    <div class="col-lg-3">
                        <form-input size="form-group--small" :modelValue="flat_number" label="Numer mieszkania" v-model="flat_number" type="text" :name="'flat_number'" :errorMessages="errorMessages"></form-input>
                    </div>
                    <div class="col-lg-6">
                        <form-input size="form-group--small" :modelValue="post_code" label="Kod pocztowy" v-model="post_code" type="text" :name="'post_code'" :errorMessages="errorMessages"></form-input>
                    </div>
                    <div class="col-lg-6">
                        <form-input size="form-group--small" :modelValue="city" label="Miasto" v-model="city" type="text" :name="'city'" :errorMessages="errorMessages"></form-input>
                    </div>
                </div>
            </div>

            <div class="alert alert-danger" v-if="errorMessages">
                <p>
                    Wystąpił błąd przetwarzania formularza, prosimy uzupełnić dane:
                </p>

                <ul>
                    <li v-for="error in errorMessages" v-html="error[0]" :key="error"></li>
                </ul>
            </div>
            <div class="form-group text-center" v-if="!hideUpdateButton">
                <button type="submit" class="btn btn-primary btn-lg">Aktualizuj dane</button>
            </div>
            <notifications group="foo" />

        </form>
    </div>
</template>

<script>
    import FormInput from "./formInput";
    import FormSelect from "./formSelect";
    import FormTextarea from "./formTextarea";
    import FormUserType from "./formUserType";

    export default {
        props: ['header', 'professions', 'redirect', 'hideUpdateButton'],

        components: {
            FormUserType,
            FormInput,
            FormSelect,
            FormTextarea,
        },
        created() {
            this.fetchData();
        },

        data() {
            return {
                id: null,
                name: null,
                last_name: null,
                specialization: null,
                pwz_number: null,
                card: null,
                university: null,
                user_type: 'person',
                work_place: null,
                errorMessages: null,
                processing: false,
                profession: null,
                userProfession: [],
                phone: null,
                company_represented: null,
                company_name: null,
                nip: null,
                street: null,
                house_number: null,
                flat_number: null,
                post_code: null,
                city: null,
                password: null,
                repeat_password: null,
                initialSnapshot: null,
            }
        },
        computed: {
            formSnapshot() {
                return JSON.stringify({
                    name: this.name,
                    last_name: this.last_name,
                    specialization: this.specialization,
                    pwz_number: this.pwz_number,
                    card: this.card,
                    university: this.university,
                    user_type: this.user_type,
                    work_place: this.work_place,
                    profession: this.profession,
                    phone: this.phone,
                    company_represented: this.company_represented,
                    company_name: this.company_name,
                    nip: this.nip,
                    street: this.street,
                    house_number: this.house_number,
                    flat_number: this.flat_number,
                    post_code: this.post_code,
                    city: this.city,
                });
            }
        },
        watch: {
            formSnapshot(newValue) {
                if (this.initialSnapshot === null) {
                    return;
                }

                this.$emit('dirty-state-changed', newValue !== this.initialSnapshot);
            }
        },

        methods: {
            fetchData(){
                axios.get('/api/user-data')
                .then((response) => {
                    this.id = response.data.data.id;
                    this.name = response.data.data.name;
                    this.last_name = response.data.data.lastName;
                    this.phone = response.data.data.phone;
                    this.userProfession = response.data.data.userProfession;
                    this.profession = response.data.data.userProfession.profession;
                    this.university = response.data.data.userProfession.university;
                    this.card = response.data.data.userProfession.card;
                    this.work_place = response.data.data.userProfession.work_place;
                    this.pwz_number = response.data.data.userProfession.pwz_number;
                    this.specialization = response.data.data.userProfession.specialization;
                    this.company_represented = response.data.data.userProfession.company_represented;
                    if(response.data.data.address){
                        this.street = response.data.data.address.street;
                        this.house_number = response.data.data.address.house_number;
                        this.flat_number = response.data.data.address.flat_number;
                        this.post_code = response.data.data.address.post_code;
                        this.city = response.data.data.address.city;
                    }
                    this.user_type = 'person';
                    if(response.data.data.company){
                        this.company_name = response.data.data.company.name;
                        this.nip = response.data.data.company.nip;
                        this.user_type = 'company';
                    }

                    this.$nextTick(() => {
                        this.initialSnapshot = this.formSnapshot;
                        this.$emit('dirty-state-changed', false);
                    });
                });
            },

            handleUpdateForm(noRedirect = false) {
                return new Promise((resolve, reject) => {
                    axios.post('/api/user-data/update', {
                        id: this.id,
                        name: this.name,
                        last_name: this.last_name,
                        profession: this.profession,
                        specialization: this.specialization,
                        pwz_number: this.pwz_number,
                        card: this.card,
                        university: this.university,
                        work_place: this.work_place,
                        user_type: this.user_type,
                        phone: this.phone,
                        company_represented: this.company_represented,
                        company_name: this.company_name,
                        nip: this.nip,
                        street: this.street,
                        house_number: this.house_number,
                        flat_number: this.flat_number,
                        post_code: this.post_code,
                        city: this.city,
                        password: this.password,
                        repeat_password: this.repeat_password,
                    })
                    .then(response => {
                        this.processing = true;
                        this.errorMessages = '';
                        this.$notify({
                            'group': 'foo',
                            'type': 'success',
                            'title': response.data.message
                        });
                        if(!noRedirect && this.redirect != ''){
                            var self = this;
                            setTimeout(function() {
                                window.location.href = self.redirect;
                            }, 1500);
                        }
                        this.initialSnapshot = this.formSnapshot;
                        this.$emit('dirty-state-changed', false);
                        this.$emit('saved');
                        resolve(true);
                    })
                    .then(response => {
                        this.processing = false;
                        this.$notify({
                            'group': 'foo',
                            'type': 'success',
                            'title': response.data.message
                        });
                    })
                    .catch(error => {
                        this.errorMessages = error.response.data.errors;
                        this.$notify({
                            'group': 'foo',
                            'type': 'error',
                            'title': error.response.data.message
                        });
                        reject(false);
                    }).then(() => {
                        window.scrollTo(0, document.querySelector('.error')?.offsetParent?.offsetTop || 0);
                    });
                });
            },
        }

    }
</script>
